import { useStaticQuery, graphql } from "gatsby"

export const useMetaCollectionJapaneseEvents = () => {
  return useStaticQuery(graphql`
    query MetaCollectionJapaneseEvents {
      japaneseEvents: markdownRemark(
        fields: {
          contentKind: { eq: "meta" }
          slug: { eq: "collection/japanese-events" }
        }
      ) {
        html
        plain: excerpt(format: PLAIN, truncate: false)
      }
    }
  `).japaneseEvents
}
